/**
 * Legacy EmailStatusApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.emailStatusApi`) keep resolving.
 *
 * The actual EmailStatusApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/email-status/email-status-api.service.ts
 */
angular.module("acme.common.service.emailStatusApi", [
  "acme.common.factory.QueryStringBuilder",
]);
